import React from 'react'

import { InfoTooltip } from '@fourthwall/components'

import * as S from './Label.styled'
import type { Props } from './types'

export const Label = ({ info, children }: Props) => {
  if (!children) {
    return null
  }

  return (
    <S.Container>
      <S.LabelContainer>
        <div>{children}</div>
        <S.Tooltip>
          <InfoTooltip content={info} />
        </S.Tooltip>
      </S.LabelContainer>
    </S.Container>
  )
}
